import React, {useEffect, useState} from 'react';
import './App.css';
import {Button, Container, Dialog, TextField, Typography} from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import datas from '../src/values.json';
interface Data {
    prixPourKm: number,
    lieu: string,
    date: string
}

const changeDate = (date: Date): string => {
    // Créez un objet Date à partir de la chaîne de caractères
    const dateObject = new Date(date);

    // Obtenez les composants de la date (jour, mois, année)
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1; // Les mois commencent à 0, donc ajoutez 1
    const year = dateObject.getFullYear() % 100; // Obtenez les deux derniers chiffres de l'année

    // Créez une chaîne de caractères au format "jj/mm/yy"
    return `${day}/${month}/${year}`;
}

const calculPrixPourKm = (prix: number, km: number): number => {
    return prix/km
}

function App() {

    const [data, setData] = useState<Data[]>([]);
    const [isOpen, setOpen] = useState<boolean>(false)

    const [addPrix, setAddPrix] = useState<number>(0)
    const [addDate, setAddDate] = useState<string>(changeDate(new Date()))
    const [addLieu, setAddLieu] = useState<string>('')
    const [addKm, setAddKm] = useState<number>(0)
    const [jsonToAdd, setJsonToAdd] = useState<any>(null)


    // Fonction pour lire les données à partir du fichier
    const readFile = () => {
        try {
           // const jsonData = JSON.parse(datas);
            setData(datas);
            console.log("Valeur: ",datas)
        } catch (error) {
            console.error('Erreur de lecture du fichier :', error);
        }
    }

    // Fonction pour écrire des données dans le fichier
    const writeFiles = () => {
        try {
            const newData = {
                prixPourKm: calculPrixPourKm(addPrix,addKm),
                lieu: addLieu,
                date: addDate
            } as Data
            //const newDataObject = JSON.parse(newData);
            const jsonString = JSON.stringify(newData);
            console.log("Donnée a ajouter au fichier ",jsonString)
            //fs.writeFileSync('./value.txt', jsonString);
            setJsonToAdd(newData)
        } catch (error) {
            console.error('Erreur d\'écriture dans le fichier :', error);
        }
    };

    useEffect(()=>{
       readFile()
    },[])

    useEffect(()=>{
        console.log("New data values", data)
    },[data])

    return (
        <Container maxWidth={false} disableGutters
                   sx={{
                       display: 'flex',
                       flexDirection: 'column',
                       alignItems: 'center'
                   }}
        >
            <Typography variant={'h2'}>Rapport prix/kilomètres</Typography>
            <LineChart width={500} height={300} data={data} style={{marginTop: '20px'}}>
                <XAxis dataKey="date" label={'Date'} />
                <YAxis label={'Prix (€)'} />
                <CartesianGrid stroke="#eee" />
                <Line type="monotone" dataKey="prixPourKm" label={'Rapport prix/kilomètres'} stroke="#8884d8" />
                <Tooltip />
                <Legend />
            </LineChart>
            <Button onClick={()=>{setOpen(true)}} sx={{marginTop: '20px'}}>Ajouter une valeur</Button>
            <Dialog open={isOpen} onClose={()=>{setOpen(false)}}>
                <Container maxWidth={false} disableGutters
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 1
                }}
                >
                    <TextField variant={'outlined'} label={'Prix'} onChange={(event)=>{setAddPrix(parseInt(event.target.value));}} sx={{marginTop: '7px'}}/>
                    <TextField variant={'outlined'} label={'Date'} onChange={(event)=>{setAddDate(event.target.value);}} sx={{marginTop: '7px'}} />
                    <TextField variant={'outlined'} label={'Lieu'} onChange={(event)=>{setAddLieu(event.target.value);}} sx={{marginTop: '7px'}} />
                    <TextField variant={'outlined'} label={'Kilometrage'} onChange={(event)=>{setAddKm(parseInt(event.target.value));}} sx={{marginTop: '7px'}} />
                    <Button onClick={writeFiles} >OK</Button>
                    <pre>{JSON.stringify(jsonToAdd, null, 2)}</pre>
                </Container>
            </Dialog>
        </Container>
    );

}


export default App;
